import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Loading from '../../../../_shared/components/Loading';
import { StyledTradeCardContainer, StyledTradeCard } from '../Styles';
import { StyledThumbnail } from '../TradeCard/Styles';
import { GridRowSize } from '../../../../_shared/types/trade';

import { StyledLoadingContent, StyledLoadingFooter } from './Styles';

const GridCardsLoading = () => {
  const themeContext = useContext(ThemeContext);
  const isLargeScreen = useMediaQuery({
    query: `(min-width: ${themeContext.BP.GRIDVIEW_DESKTOP_WH})`
  });
  const rowSize = isLargeScreen ? GridRowSize.LARGE : GridRowSize.SMALL;
  return (
    <>
      {[...Array(rowSize).keys()].map(col => (
        <StyledTradeCardContainer key={`grid-card-loading-${col}`}>
          <StyledTradeCard>
            <StyledThumbnail>
              <Loading width="100%" height="100%" />
            </StyledThumbnail>
            <StyledLoadingContent>
              <Loading width="148px" height="100%" />
            </StyledLoadingContent>
            <StyledLoadingFooter>
              <Loading width="93px" height="22px" />
            </StyledLoadingFooter>
          </StyledTradeCard>
        </StyledTradeCardContainer>
      ))}
    </>
  );
};

export default GridCardsLoading;
